import { Injectable, autobind } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import { AreaList, ContestInfo, Option } from '@/types';

import {
  normalStringPattern,
  encryptionPhonePattern,
  disableDigitValidator,
  b2cAndContestGradeMapping,
  isInIframe,
  environment,
} from '@/utils';
import { VCodeService } from './vcode.service';
import moment from 'moment';
import { omitBy } from 'lodash-es';
import EventBusItemDetail from '@/eventBus/itemDetail';
interface AreaOption {
  id: number;
  parentId?: number;
  areaName: string;
  isLeaf: boolean;
  children?: Array<AreaOption>;
  areaType: number; // 1表示 省 2表示 市 3 表示 区县
  loading: boolean;
}

export interface FormState {
  grade?: string;
  className: string;
  schoolId?: number;
  school?: string;
  tempSchoolName?: string;
  teacherName: string;
  area: Array<number>;
  cardNo: string;
  cardType?: number;
  mobile: string;
  encryptionPhone: string;
  contestScheduleId?: number;
  oldContestScheduleId?: number;
  sex?: number;
  userName?: string;
  birthday?: string;
  certificateGetMethod?: number;
  certificatePostAddress?: string;
  smsCode?: string;
  areaId?: string;
  examNo?: string;
  teacherPhone?: string;
}

interface SmsConfType {
  visible?: boolean;
  imgCode?: string;
  count: number;
  status: string;
}

interface IB2cState {
  userInfo?: Record<string, any>;
  schoolName?: string;
}
@Injectable()
export class ApplyNewService {
  public itemId!: number; // 当前赛项的ID
  public item!: ContestInfo; // 报名页所需要的赛事信息

  public scheduleList: Array<Option> = []; // 报考组别下拉框需要的数据
  public areaList: AreaList = []; // 考生所在地区的级联下拉框需要的数据
  public schoolList: Array<Option> = []; // 考生所在学校下拉框需要的数据
  public areaNodeList: Array<any> = [];

  public smsCodeConf: SmsConfType = {
    visible: false,
    imgCode: '',
    count: 60,
    status: 'initial',
  };

  public formState: FormState = {
    grade: undefined,
    className: '',
    schoolId: undefined,
    school: '',
    tempSchoolName: '',
    teacherName: '',
    area: [],
    cardNo: '',
    cardType: undefined,
    mobile: '', // 加密手机号，中间4位是*
    encryptionPhone: '', // 加密手机号，中间4位是字母
    contestScheduleId: undefined,
    oldContestScheduleId: undefined,
    sex: undefined,
    userName: '',
    birthday: '',
    certificateGetMethod: undefined,
    certificatePostAddress: '',
    smsCode: undefined,
    areaId: undefined,
    examNo: '',
    teacherPhone: '',
  };

  public b2cState: IB2cState = {
    userInfo: undefined,
  };

  public errorInfo: any = null;

  constructor(
    public daoService: DaoService,
    public VCodeService: VCodeService
  ) {}

  public setItemId(id: number) {
    this.itemId = id;
  }

  // 是否需要获取赛区id 通过报名时间配置获取
  public get needAreaId() {
    return this.item?.regConfig?.regType === 1;
  }

  public get ConfUserName() {
    return this.getRegConfigByAttr('userName');
  }
  public get ConfSex() {
    return this.getRegConfigByAttr('sexType');
  }
  public get ConfContestScheduleId() {
    return this.getRegConfigByAttr('contestScheduleId');
  }
  public get ConfMobile() {
    return this.getRegConfigByAttr('mobile');
  }
  public get ConfCardType() {
    return this.getRegConfigByAttr('cardType');
  }
  public get ConfCardNo() {
    return this.getRegConfigByAttr('cardType');
  }
  public get ConfArea() {
    return this.getRegConfigByAttr('area');
  }
  public get ConfTempSchoolName() {
    return this.getRegConfigByAttr('school');
  }
  public get ConfTeacherName() {
    return this.getRegConfigByAttr('teacher');
  }
  public get ConfBirthday() {
    return this.getRegConfigByAttr('birthday');
  }
  public get ConfCertificateGetMethod() {
    return this.getRegConfigByAttr('certificateType');
  }
  public get ConfClassName() {
    return this.getRegConfigByAttr('classInfo');
  }
  public get ConfGrade() {
    return this.getRegConfigByAttr('grade');
  }
  public get ConfExamNo() {
    return this.getRegConfigByAttr('examNo');
  }
  public get ConfTeacherPhone() {
    return this.getRegConfigByAttr('teacherPhone');
  }
  public get rules() {
    return {
      userName: [
        {
          required: this.ConfUserName.required,
          message: '请输入考生姓名',
          trigger: 'blur',
          whitespace: true,
        },
        {
          min: 1,
          max: 50,
          message: '最多50字符',
          trigger: 'blur',
        },
        {
          validator: disableDigitValidator,
          trigger: 'blur',
        },
      ],
      sex: [
        {
          required: this.ConfSex.required,
          message: '请选择考生性别',
        },
      ],
      examNo: [
        {
          required: this.ConfExamNo.required,
          message: '请输入考生考号',
        },
      ],
      contestScheduleId: [
        {
          required: this.ConfContestScheduleId.required,
          message: '请选择报名组别',
        },
      ],
      mobile: [
        {
          required: this.ConfMobile.required,
          message: '请填写报名手机号',
          trigger: 'blur',
        },
        {
          pattern: encryptionPhonePattern,
          message: '手机号格式不正确',
          trigger: 'blur',
        },
      ],
      cardType: [
        {
          required: this.ConfCardType.required,
          message: '请选择证件类型',
        },
      ],
      cardNo: [
        {
          required: this.ConfCardNo.required,
          message: '请填写证件号',
          trigger: 'blur',
        },
        {
          min: 1,
          // max: 18,
          // message: '最多18字符',
          validator: (rule: any, value: any) => {
            return new Promise((resolve, reject) => {
              if (this.formState.cardType === 4) {
                if (value.length > 30) {
                  reject('最多30字符');
                } else {
                  resolve(true);
                }
              } else if (value.length > 18) {
                reject('最多18字符');
              } else {
                resolve(true);
              }
            });
          },
          trigger: 'blur',
        },
        {
          validator: (rule: any, value: any) => {
            return new Promise((resolve, reject) => {
              if (this.formState.cardType === 1) {
                if (normalStringPattern.test(value)) {
                  resolve(true);
                } else {
                  reject('不能包含特殊字符');
                }
              } else {
                resolve(true);
              }
            });
          },
          trigger: 'blur',
        },
      ],
      area: [
        {
          type: 'array',
          required: this.ConfArea.required,
          message: '请选择考生学校所在地区',
          trigger: 'blur',
        },
      ],
      tempSchoolName: [
        {
          required: this.ConfTempSchoolName.required,
          min: 1,
          max: 30,
          message: '最多30字符',
          trigger: 'blur',
        },
      ],
      teacherName: [
        {
          required: this.ConfTeacherName.required,
          min: 1,
          max: 30,
          message: '最多30字符',
          trigger: 'blur',
        },
        {
          validator: disableDigitValidator,
          trigger: 'blur',
        },
      ],
      className: [
        {
          required: this.ConfClassName.required,
          validator: (rule: any, value: any) => {
            if (value !== 0 && !value && !this.ConfClassName.required) {
              return Promise.resolve(true);
            }
            if (value <= 10000 && value >= 1) {
              return Promise.resolve(true);
            }
            return Promise.reject(
              '仅支持填写1~10000之间的数字（包括1和10000）'
            );
          },
          trigger: 'blur',
        },
      ],
      birthday: [
        {
          required: this.ConfBirthday.required,
          message: '请选择考生出生年月',
        },
      ],
      certificateGetMethod: [
        {
          required: this.ConfCertificateGetMethod.required,
          message: '请选择证书获取方式',
        },
      ],
      grade: [
        {
          required: this.ConfGrade.required,
          message: '请选择在考年级',
        },
      ],
      certificatePostAddress: [
        {
          required: true,
          trigger: 'blur',
          message: '请填写证书邮寄地址',
        },
      ],
      smsCode: [
        {
          required: true,
          min: 1,
          max: 6,
          message: '请输入6位数字验证码',
          trigger: ['blur', 'change'],
        },
      ],
      areaId: [
        {
          required: true,
          message: '请选择考试时间',
          type: 'number',
          trigger: ['blur', 'change'],
        },
      ],
      teacherPhone: [
        {
          required: this.ConfTeacherPhone.required,
          message: '请填写所在学校的信息技术教师手机号',
          trigger: 'blur',
        },
        {
          pattern: encryptionPhonePattern,
          message: '手机号格式不正确',
          trigger: 'blur',
        },
      ],
    };
  }

  @autobind
  public getRegConfigByAttr(name: string) {
    let configVal = this.item?.regConfig?.[name];
    // 特殊处理
    if (['contestScheduleId'].includes(name)) {
      configVal = 0;
    }
    if (typeof configVal === 'number') {
      return {
        show: configVal !== 1,
        required: configVal === 0,
      };
    }
    return {
      show: true,
      required: false,
    };
  }

  @autobind
  public loadAreaData(selectedOptions?: AreaOption[]) {
    if (!this.formState.contestScheduleId) return;
    const contestScheduleId: any = this.needAreaId
      ? undefined
      : this.formState.contestScheduleId;
    const targetOption =
      selectedOptions && selectedOptions[selectedOptions.length - 1];
    if (targetOption) {
      targetOption.loading = true;
    }

    return this.daoService
      .getAreaList4Register(
        contestScheduleId,
        targetOption ? targetOption.areaType + 1 : 1,
        targetOption && targetOption.id
      )
      .then(res => {
        if (targetOption) {
          targetOption.loading = false;
        }
        if (res && res.length) {
          const arr = res.map(item => ({
            id: item.id,
            parentId: targetOption && targetOption.id,
            areaName: item.areaName,
            isLeaf: targetOption ? targetOption.areaType >= 2 : false,
            areaType: targetOption ? targetOption.areaType + 1 : 1,
            loading: false,
          }));
          if (targetOption) {
            targetOption.children = arr;
          } else {
            this.areaList = arr;
          }
        } else {
          if (targetOption) {
            targetOption.isLeaf = true;
          } else {
            this.areaList = [];
          }
        }
      });
  }

  @autobind
  getScheduleIdAreaList() {
    const scheduleId = this.formState.contestScheduleId;
    if (!scheduleId) return;
    this.daoService.getAreaNodeList({ scheduleId }).then(res => {
      const areaNodeList = res || [];
      this.areaNodeList = areaNodeList.map((el: any) => {
        const startTime = moment(el.examStartTimestamp)
          .utcOffset(8)
          .format('YYYY-MM-DD HH:mm:ss');
        const endTime = moment(el.examEndTimestamp)
          .utcOffset(8)
          .format('YYYY-MM-DD HH:mm:ss');
        return {
          label: `${startTime} 至 ${endTime}`,
          value: el.areaId,
        };
      });
    });
  }

  @autobind
  public onContestScheduleIdChange() {
    this.formState.area = [];
    const inIframe = isInIframe();
    const { tempSchoolName } = this.formState;
    if (inIframe && tempSchoolName) {
      this.formState.tempSchoolName = tempSchoolName;
    } else {
      this.formState.tempSchoolName = '';
    }
    this.formState.school = '';
    this.formState.schoolId = undefined;
    this.formState.areaId = undefined;
    this.schoolList = [];
    this.areaList = [];
    if (this.needAreaId) {
      // 获取考试时间列表
      this.getScheduleIdAreaList();
    }
    this.loadAreaData();
  }

  @autobind
  public onAreaChange() {
    this.formState.tempSchoolName = '';
    this.formState.school = '';
    this.formState.schoolId = undefined;
    this.schoolList = [];
  }

  // 修改于 2024-03-19 产品要求组别全部展示 --新增--
  @autobind
  public getAllScheduleList() {
    const params = {};
    return this.daoService.getScheduleList(this.itemId, params).then(res => {
      this.scheduleList = res.map(item => ({
        value: item.id,
        label: item.name,
      }));
    });
  }

  @autobind
  public getSchoolList(schoolName: string) {
    const { area } = this.formState;
    // if (!(area && area[0] && area[1])) return;
    const [provinceId, cityId] = area || [undefined, undefined];
    return this.daoService
      .getSchoolList4Register(provinceId, cityId, schoolName)
      .then(res => {
        let contestArr: number[] = [];
        if (environment === 'production') {
          contestArr = [2168];
        } else {
          contestArr = [303];
        }
        this.schoolList = res
          .map(item => ({
            value: item.id,
            label: item.schoolName,
          }))
          .filter(item => {
            if (contestArr.includes(this.itemId)) {
              return false;
            }
            return true;
          });
      });
  }

  @autobind
  public onSchoolSelect(key: any) {
    const found = this.schoolList?.find(o => o.value === key);
    if (found) {
      this.formState.schoolId = key;
      this.formState.school = found.label as string;
      this.formState.tempSchoolName = found.label as string;
    }
  }

  @autobind
  public submit(hasExamId: any, exParams?: any) {
    const formState = this.formState;
    const area = formState.area;
    const areaList = this.areaList;

    if (formState.tempSchoolName !== formState.school) {
      // 如果学校名有变动，那么以变动后的学校名为准
      formState.schoolId = undefined;
      formState.school = formState.tempSchoolName;
    }

    const formData: any = omitBy(
      {
        activityId: this.item.activityId,
        contestId: this.itemId,
        contestScheduleId: formState.contestScheduleId,
        userName: formState.userName,
        cardNo: formState.cardNo,
        cardType: formState.cardType,
        className: formState.className ? `${formState.className}班` : undefined,
        provinceId: area[0],
        province: this.getAreaNameById(area[0], areaList),
        cityId: area[1],
        city: this.getAreaNameById(area[1], areaList),
        districtId: area[2],
        district: this.getAreaNameById(area[2], areaList),
        grade: formState.grade as string,
        mobile: formState.mobile,
        encryptionPhone: formState.encryptionPhone,
        schoolId: formState.schoolId,
        school: formState.school,
        sex: formState.sex,
        teacherName: formState.teacherName,
        teacherPhone: formState.teacherPhone,
        birthday: formState.birthday,
        certificateGetMethod: formState.certificateGetMethod,
        certificatePostAddress: formState.certificatePostAddress,
        examNo: formState.examNo,
        ...exParams,
      },
      value => {
        return [null, undefined, ''].includes(value);
      }
    );
    if (hasExamId) {
      formData.newContestScheduleId = formData.contestScheduleId;
      formData.contestScheduleId = formState.oldContestScheduleId;
      return this.daoService.updataRegister(formData);
    } else {
      return this.daoService.register(formData);
    }
  }

  public getAreaNameById(id: number, list: AreaList): string {
    for (const item of list) {
      if (item.id === id) return item.areaName;
      if (item.children && item.children.length) {
        const res = this.getAreaNameById(id, item.children);
        if (res) {
          return res;
        }
      }
    }
    return '';
  }

  /**
   * 获取历史报名信息，用户表单回显
   *
   * @return {*}
   * @memberof ApplyService
   */
  public getApplyInfoFromHistory() {
    return this.daoService.getRegisterInfo().then(res => {
      this.formState.userName = this.formState.userName
        ? this.formState.userName
        : res.userName || '';
      this.formState.mobile = res.mobile || '';
      this.formState.encryptionPhone = res.encryptionPhone || '';
      this.formState.cardType = res.cardType || undefined;
      this.formState.cardNo = res.cardNo || '';
    });
  }

  /**
   * 获取报名页所需要的赛事信息
   *
   * @return {*}
   * @memberof ApplyService
   */
  public getContestInfo(isEdit?: number) {
    const errStatusMap: any = {
      6003: '该活动报名尚未开始',
      6004: '报名已截止',
    };
    this.errorInfo = null;
    return this.daoService
      .getContestInfo(this.itemId, isEdit)
      .then(res => {
        this.item = res;
        EventBusItemDetail.emit('item-new', res);
        this.dealB2cLogic();
      })
      .catch((err: any) => {
        const { errCode } = err;
        this.errorInfo = {
          text: errStatusMap[errCode],
          errCode,
        };
      });
  }

  @autobind
  public showImgVeriy(show = true) {
    this.smsCodeConf.visible = show;
  }

  @autobind
  public sendVerifiedCode(options: any) {
    if (!this.smsCodeConf.imgCode || !this.formState.mobile) return;
    if (this.smsCodeConf.status === 'initial') {
      this.smsCodeConf.status = 'pending';
      this.daoService
        .sendVerifiedCode(
          this.formState.mobile,
          this.smsCodeConf.imgCode,
          this.VCodeService.imageCodeUuid
        )
        .then(() => {
          this.showImgVeriy(false);
          this.smsCodeConf.count = 60;
          this.smsCodeConf.status = 'countdown';
          this.smsCountDown();
        })
        .catch(e => {
          this.smsCodeConf.status = 'initial';
          // 获取报错之后，需要自动清除并更新imgaeCode
          options.errFun && options.errFun();
          throw e;
        });
    } else {
      return Promise.resolve();
    }
  }

  @autobind
  public smsCountDown() {
    if (this.smsCodeConf.count > 0 && this.smsCodeConf.count <= 60) {
      this.smsCodeConf.count--;
      setTimeout(() => {
        this.smsCountDown();
      }, 1000);
    } else {
      this.smsCodeConf.count = 0;
      this.smsCodeConf.status = 'initial';
    }
  }

  @autobind
  public dealB2cLogic() {
    if (!this.b2cState?.userInfo) {
      return;
    }
    if (!this.item) {
      return;
    }
    this.replaceFormStateFromB2c();
  }

  @autobind
  public initB2CState(b2cData: any) {
    this.b2cState = b2cData;
    this.dealB2cLogic();
  }

  @autobind
  public replaceFormStateFromB2c() {
    // key: formState key   value: b2cState key
    const replaceAttrObj: Record<string, string> = {
      // 年级
      grade: 'gradeId',
      // 考试姓名
      userName: 'name',
      // 班级
      className: 'realClassId',
      // 学校
      tempSchoolName: 'schoolName',
      // 性别
      // sex: 'sex',
    };
    const userInfo = this.b2cState?.userInfo || {};
    const totalUserInfo: any = {
      ...userInfo,
      schoolName: this.b2cState?.schoolName || '',
    };
    this.mappingRelationGrade();
    Object.keys(replaceAttrObj).forEach((key: string) => {
      const b2cStateKey = replaceAttrObj[key];
      const b2cStateVal = totalUserInfo[b2cStateKey];
      if (!['', null, undefined].includes(b2cStateVal)) {
        if (b2cStateKey === 'gradeId') {
          this.formState.grade = this.mappingRelationGrade();
        } else {
          (this.formState as any)[key] = b2cStateVal;
        }
      }
    });
  }

  @autobind
  private mappingRelationGrade() {
    const contestGradeList = this.item?.regConfig?.gradeInfoList || [];
    const b2cUserInfo = this.b2cState?.userInfo;
    const getFilterGrade = (gradeId: number) =>
      contestGradeList.find((el: any) => el.gradeId === gradeId);
    // 判断有没有学前
    const hasPreSchool = getFilterGrade(1);
    const b2cUserGrade = b2cUserInfo?.gradeId;
    // 学前映射年级可能没有配置
    if (b2cUserGrade > 9) {
      return hasPreSchool ? 1 : undefined;
    }
    const mappingGrade: number[] =
      b2cAndContestGradeMapping[b2cUserGrade] || [];
    // 判断年级有没有设置初四年级
    const hasFourthJuniorGrade = getFilterGrade(11);
    const len = mappingGrade.length;
    if (len === 1) {
      return mappingGrade[0];
    } else if (len === 2) {
      // ex: 六年级对应的
      const hasFirstIndexGrade = getFilterGrade(mappingGrade[0]);
      if (hasFirstIndexGrade) {
        return hasFirstIndexGrade.gradeId;
      }
      const hasSecondIndexGrade = getFilterGrade(mappingGrade[1]);
      if (hasSecondIndexGrade) {
        return hasSecondIndexGrade.gradeId;
      }
      return undefined;
    } else if (len === 3) {
      // ex: 七年级对应的
      const hasFirstIndexGrade = getFilterGrade(mappingGrade[0]);
      if (hasFirstIndexGrade) {
        return hasFirstIndexGrade.gradeId;
      }
      // 如果存在配置初四
      if (hasFourthJuniorGrade) {
        const hasSecondIndexGrade = getFilterGrade(mappingGrade[1]);
        if (hasSecondIndexGrade) {
          return hasSecondIndexGrade.gradeId;
        }
      } else {
        const hasThirdIndexGrade = getFilterGrade(mappingGrade[2]);
        if (hasThirdIndexGrade) {
          return hasThirdIndexGrade.gradeId;
        }
      }
      return undefined;
    }
  }
}
